import React from "react";
import { LongTextLabel, Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { Group } from "Types";
import { apiErrorToast } from "Utils";
import { useDeleteGroupMutation } from "../../services/organizations.api";
import styles from "./removeGroup.module.scss";

type DeleteMemberProps = {
  group: Group;
  isOpen: boolean;
  onClose: () => void;
};

const RemoveGroup = ({
  group,
  isOpen,
  onClose,
}: DeleteMemberProps): React.JSX.Element => {
  const [deleteGroup] = useDeleteGroupMutation();

  const handleDeleteGroup = async () => {
    try {
      await deleteGroup({
        groupId: group.group_id,
      }).unwrap();

      Toast.show({
        title: "Group deleted",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not delete group");
    }
  };

  return (
    <Dialog
      title={`Delete group ${group.name} from the organization?`}
      confirmText="Yes, delete this group"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={handleDeleteGroup}
      cancelButtonColor="primary"
      confirmButtonColor="error"
      dangerZone={group.name}
    >
      <div className={styles.content}>
        Are you sure you want to delete
        <LongTextLabel label={group.name} className={styles["delete-group"]} />
        from the organization?
      </div>
      <div>
        Deleting this group will delete all of the data belonging to this group,
        including file stream uploads, projects and packages.
      </div>
    </Dialog>
  );
};

export default RemoveGroup;
